import { render, staticRenderFns } from "./Reviewdetails.vue?vue&type=template&id=fff04b06&scoped=true&"
import script from "./Reviewdetails.vue?vue&type=script&lang=js&"
export * from "./Reviewdetails.vue?vue&type=script&lang=js&"
import style0 from "./Reviewdetails.vue?vue&type=style&index=0&id=fff04b06&scoped=true&lang=css&"
import style1 from "./Reviewdetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff04b06",
  null
  
)

export default component.exports